import PrimaryButton from "../../../common/PrimaryButton/PrimaryButton";
import React from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@material-ui/core";

interface DeleteServiceTypeDialogInterface {
    open: boolean;
    onClose: () => void;
    onDelete: () => void;
    sideMenuClasses: any;
    serviceId: string | null;
    serviceDisplayName: string | null;
}

const DeleteServiceTypeDialog = (props: DeleteServiceTypeDialogInterface) => {
    const {
        open,
        onClose,
        onDelete,
        sideMenuClasses,
        serviceId,
        serviceDisplayName,
    } = props;

    const getAddUpdateDialogTitleContent = () => {
        return (
            <span className={sideMenuClasses.dialogTitleStyle}>
                {`Delete `}
                <strong>{serviceDisplayName || ""}</strong>
                {` Service Type?`}
            </span>
        );
    };

    const getAddUpdateDialogDetailsContent = () => {
        return (
            <span className={sideMenuClasses.dialogDetailsStyle}>
                This action is <strong>permanent</strong> and cannot be undone.
                <br />
                <span className={sideMenuClasses.dialogSubDetailsStyle}>
                    Note: A service type can only be deleted if there are{" "}
                    <strong>no zones associated</strong> with it.
                </span>
            </span>
        );
    };

    const getAddUpdateDialogActions = () => {
        return (
            <>
                <PrimaryButton
                    buttonLabel="CANCEL"
                    buttonVariant="outlined"
                    className={sideMenuClasses.buttonStyles}
                    onClick={onClose}
                />
                <PrimaryButton
                    buttonLabel="PROCEED"
                    buttonVariant="contained"
                    className={sideMenuClasses.deleteButtonStyles}
                    onClick={onDelete}
                />
            </>
        );
    };

    return (
        <Dialog
            classes={{
                paperWidthSm: sideMenuClasses.dialogRoot,
            }}
            onClose={onClose}
            open={open}
        >
            <DialogTitle>{getAddUpdateDialogTitleContent()}</DialogTitle>
            <DialogContent>{getAddUpdateDialogDetailsContent()}</DialogContent>
            <DialogActions className="do-not-print">
                {getAddUpdateDialogActions()}
            </DialogActions>
        </Dialog>
    );
};

export default React.memo(DeleteServiceTypeDialog);
